import { useQueries } from '@tanstack/react-query';
import { api } from '../../api/client';
import { useAuthStore } from '../../store/authStore';
import { getDiaSemanaFromDate } from '../../api/hooks/useHorarios';
import type { DiaSemana, HorarioAula } from '../../types/models';
import { ROUTES } from '../../api/routes';

export const DIAS_UTEIS: DiaSemana[] = ['SEGUNDA', 'TERCA', 'QUARTA', 'QUINTA', 'SEXTA', 'SABADO'];

export function useProfessorGradeSemanal(professorId?: string) {
  const escolaId = useAuthStore((s) => s.escolaId);

  const queries = useQueries({
    queries: DIAS_UTEIS.map((dia) => ({
      queryKey: ['horarios-dia-grade', escolaId, professorId, dia],
      queryFn: async () => {
        const { data } = await api.get(ROUTES.horarios.porEscola(escolaId!), {
          params: { professorId, diaSemana: dia },
        });
        const list: HorarioAula[] = Array.isArray(data) ? data : data.data ?? [];
        const aulas = list
          .filter((h) => h.tipo === 'AULA')
          .sort((a, b) => (a.horaInicio || '').localeCompare(b.horaInicio || ''));
        return { dia, aulas, total: aulas.length };
      },
      enabled: !!escolaId && !!professorId,
      staleTime: 120_000,
    })),
  });

  const isLoading = queries.some((q) => q.isLoading);
  const counts: Record<DiaSemana, number> = {
    SEGUNDA: 0,
    TERCA: 0,
    QUARTA: 0,
    QUINTA: 0,
    SEXTA: 0,
    SABADO: 0,
  };
  const slotsByDia: Record<DiaSemana, HorarioAula[]> = {
    SEGUNDA: [],
    TERCA: [],
    QUARTA: [],
    QUINTA: [],
    SEXTA: [],
    SABADO: [],
  };

  queries.forEach((q, i) => {
    const dia = DIAS_UTEIS[i];
    if (q.data) {
      counts[dia] = q.data.total;
      slotsByDia[dia] = q.data.aulas;
    }
  });

  const totalAulasSemana = Object.values(counts).reduce((s, n) => s + n, 0);

  function aulasNoDia(isoDate: string): HorarioAula[] {
    const dia = getDiaSemanaFromDate(isoDate);
    if (!dia) return [];
    return slotsByDia[dia] ?? [];
  }

  function contagemNoDia(isoDate: string): number {
    return aulasNoDia(isoDate).length;
  }

  return { counts, slotsByDia, totalAulasSemana, isLoading, aulasNoDia, contagemNoDia };
}
